import React, { useEffect, useReducer } from "react";
import { View, Text, TouchableOpacity } from "react-native";

import Button from "components/Partials/Buttons";
import PatientDetails from "./Patients/PatientDetails";
import PatientEditForm from "./Patients/PatientEditForm";
import PatientList from "./Patients/PatientsList";
import { deepCopy, stateReducer } from "components/helpers/stateReducer";
import { getAppointmentCardText } from "./Appointments";

// const buildPatientSavePayload = (patient, uploadedProfileImageId=null) => ({
//   patient_id: patient.patient_id,
//   name: patient.name ?? "",
//   birth_date: patient.birth_date ?? "",
//   gender: patient.gender ?? "",
//   weight: patient.weight ?? "",
//   color: patient.color ?? "",
//   species: patient.species ?? patient.species_id ?? null,
//   breed: patient.breed ?? patient.breed_id ?? null,
//   second_breed: patient.second_breed ?? patient.second_breed_id ?? null,
//   ...(uploadedProfileImageId ? { profile_image_id: uploadedProfileImageId } : {}),
// });

// const getHomeResumeContext = ()=>(window?.main?.temp?.__home_resume_context__ || null);

// const clearHomeResumeContext = () => {
//   if (window?.main?.temp?.__home_resume_context__) {
//     delete window.main.temp.__home_resume_context__;
//   }
// };

const Home = () => {
  const _theme = window.main.theme;
  const userProfile = window.main.lib.getUserProfile();

  // State for patients array, selected item, edit mode
  const [homeState, homeSetState] = useReducer(stateReducer, {
    patientsData: [],
    appointmentsData: [],
    initComplete: false,
    selectedPatientId: 0,
    editingPatientId: 0,
  });

  // Helper
  const getPatientById = (pid) => {
    return (!!Number(pid) ? homeState.patientsData.find(p=>(Number(p.patient_id)===Number(pid))) : null);
  };

  // Pull all patients on mount/refresh
  const fetchPatientsData = async () => {
    try {
      window.main.lib.setLoadingState(true);
      const resp = await window.main.axios.get(window.main.api.getPatients);
    } catch (err) {
      window.main.lib.setStatusState(window.main.lib.parseErrorMessage(err));
    } finally {
      window.main.lib.setLoadingState(false);
    }
  };

  // Helper fetch appointments
  const fetchHomeData = async () => {
    try {
      const _stateProps = [
        { key: "initComplete", type: "boolean", initComplete: true }
      ]
      window.main.lib.setLoadingState(true);
      const [patientsResp, apptsResp] = await Promise.all([ window.main.axios.get(window.main.api.getPatients), window.main.axios.get(window.main.api.getAppointments) ]);
      if (!!patientsResp && !!patientsResp.error) {
        window.main.lib.setStatusState(window.main.lib.parseErrorMessage(patientsResp.error, "An error occurred while loading Pets data."));
      } else {
        _stateProps.push({ key: "patientsData", type: "array", patientsData: patientsResp.data });
      }
      if (!!apptsResp && !!apptsResp.error) {
        window.main.lib.setStatusState(window.main.lib.parseErrorMessage(apptsResp.error, "An error occurred while loading Appointments data."));
      } else {
        _stateProps.push({ key: "appointmentsData", type: "array", appointmentsData: apptsResp.data });
      }
      // Update all states at once:
      homeSetState(_stateProps);
    } catch (err) {
      window.main.lib.setStatusState(window.main.lib.parseErrorMessage(err));
    } finally {
      window.main.lib.setLoadingState(false);
    }
  };

  //useEffect(() => { fetchPatientsData(); }, []);
  useEffect(() => {
    fetchHomeData();
  }, []);

  // useEffect(() => {
  //   // const resume = getHomeResumeContext();
  //   // if (!resume) {
  //   //   return;
  //   // }
  //   if (resume?.selectedPatientId) {
  //     homeSetState([
  //       {
  //         key: "selectedPatientId",
  //         type: "string",
  //         selectedPatientId: String(resume.selectedPatientId),
  //       },
  //     ]);
  //   } else {
  //     homeSetState([
  //       {
  //         key: "selectedPatientId",
  //         type: "string",
  //         selectedPatientId: null,
  //       },
  //     ]);
  //   }
  //   clearHomeResumeContext();
  // }, [homeState.patientsData.length]);

  // Central Image Upload
  const handlePatientImageChange = async (patient_id, file) => {
    const _patientsDataCopy = deepCopy(homeState.patientsData);
    const _patient = _patientsDataCopy.find(o=>(Number(o.patient_id)===Number(patient_id)));
    if (!_patient) {
      window.main.lib.setStatusState("Patient not found.");
      return;
    }
    const formData = new FormData();
    formData.append("document", file, file.name);
    formData.append("entity", "patient_profile_temp");
    formData.append("entity_id", String(patient_id));
    try {
      window.main.lib.setLoadingState(true);
      const resp = await window.main.axios.post(window.main.api.uploadPatientImage, formData);
      const uploadedProfileImageId = (Number(resp.data.documentId)||0);
      if (!uploadedProfileImageId) {
        window.main.lib.setStatusState( resp?.data?.error || resp?.data?.message || "Image upload failed." );
        return;
      }
      _patient.profile_image_id = uploadedProfileImageId;
      // Optimistic local update so UI changes immediately
      homeSetState([
        {
          key: "patientsData",
          type: "array",
          patientsData: _patientsDataCopy,
        },
      ]);
      // // Persist the temp image to the real patient record
      // const savePayload = buildPatientSavePayload(_patient, uploadedProfileImageId);
      // console.log("setPatient image payload:", savePayload);
      // await window.main.axios.post(window.main.api.setPatient, savePayload);
      // // Pull fresh saved data
      // await fetchPatientsData();
      window.main.lib.setStatusState("Image uploaded successfully.");
    } catch (err) {
      console.log("handlePatientImageChange error:", err);
      window.main.lib.setStatusState(window.main.lib.parseErrorMessage(err));
    } finally {
      window.main.lib.setLoadingState(false);
    }
  };

  // Central Save (edit) logic
  const handleEditSave = async (payload) => {
    window.main.lib.setLoadingState(true);
    try {
      await window.main.axios.post(window.main.api.setPatient, payload);
      await fetchPatientsData();
      window.main.lib.setStatusState("Patient updated successfully.");
      // Deselect edit, return to detail
      homeSetState([
        { key: "editingPatientId", type: "number", editingPatientId: 0 },
        { key: "selectedPatientId", type: "number", selectedPatientId: (Number(payload.patient_id)||0) },
      ]);
    } catch (err) {
      window.main.lib.setStatusState(window.main.lib.parseErrorMessage(err));
    } finally {
      window.main.lib.setLoadingState(false);
    }
  };

  const { selectedPatientId, editingPatientId } = homeState;
  const selectedPatient = getPatientById(selectedPatientId);
  const editingPatient = getPatientById(editingPatientId);

  const onPressRequestAppt = () => {
    window.main.lib.setCurrentView("appointments");
  };

  return (
    <View style={{..._theme.container,borderWidth:0,paddingTop:18,paddingBottom:24,paddingHorizontal:24}}>
      <View style={{..._theme.cardBlock,marginBottom:14}}>
        <Text style={_theme.pageTitleText}>
          Welcome, {(`${userProfile.first_name || ""} ${userProfile.last_name || ""}`).trim() || "Guest"}
        </Text>
      </View>

      <View style={{..._theme.cardBlock}}>
        {editingPatient ? (
          <PatientEditForm patientData={editingPatient} containerStyle={{..._theme.cardBlock,marginTop:44}} onCancel={()=>{homeSetState([{ key: "editingPatientId", type: "number", editingPatientId: null }])} } onSave={handleEditSave} onImageChange={file => handlePatientImageChange(editingPatient.patient_id, file)} />
        ) : selectedPatient ? (
          <>
            <Button ficon="arrow-left" text="Back to My Pets" type="link" onPress={()=>{homeSetState([{ key: "selectedPatientId", type: "number", selectedPatientId: 0 }])}} style={{alignSelf:"flex-start",paddingHorizontal:0,marginBottom:10,marginTop:0}} />
            <PatientDetails patient={selectedPatient} containerStyle={{..._theme.cardBlock}} onEdit={()=>{homeSetState([{ key: "editingPatientId", type: "number", editingPatientId: Number(selectedPatient.patient_id) }])}} onImageChange={file => handlePatientImageChange(selectedPatient.patient_id, file)} />
            <Button text="Request Appointment" type="primary" size="large" onPress={onPressRequestAppt} style={{marginTop:20,width:"100%"}} />
          </>
        ) : (
          <View style={{..._theme.cardBlock}}>
            {homeState.appointmentsData.length>0 && (
              <>
                <View style={{..._theme.containerTitle,height:30,marginBottom:16,paddingBottom:0,paddingTop:0,paddingLeft:0,paddingRight:0}}>
                  <Text style={_theme.containerTitleText}>
                    My Appointments: ({homeState.appointmentsData.length})
                  </Text>
                </View>
                  {homeState.appointmentsData.map((appt, idx) => {
                    const onPressAppt = ()=>{
                      // window.main.lib.setCurrentView({
                      //   viewKey: "appointments",
                      //   validPath: "appointments/"+appt.appointment_id,
                      //   viewParams: {appointment_id: appt.appointment_id},
                      // });
                      window.main.lib.setCurrentView("appointments/appointment_id/"+appt.appointment_id);
                    };
                    return (
                      <TouchableOpacity key={appt.appointment_id || appt.id || idx} onPress={onPressAppt} style={{width:"100%",minHeight:78,backgroundColor:"#ffffff",borderRadius:_theme.borderRadius,marginBottom:16,paddingVertical:16,paddingHorizontal:16,alignItems:"center",justifyContent:"center",...window.main.theme.boxShadowStyle}}>
                      <Text style={{color:"#222222",fontWeight:"600",fontSize:15,textAlign:"center",lineHeight:22}}>
                        {getAppointmentCardText(appt, homeState.patientsData)}
                      </Text>
                    </TouchableOpacity>
                    );
                  })}
                <View style={{flexDirection:"row",justifyContent:"center",marginBottom:24,width:"100%",}}>
                  <Button text="Request Appointment" type="primary" size="large" style={{width:"100%",height:48,borderRadius:_theme.borderRadius}} onPress={onPressRequestAppt} />
                </View>
              </>
            )}

            <View style={{..._theme.containerTitle,height:30,marginBottom:16,paddingBottom:0,paddingTop:0,paddingLeft:0,paddingRight:0}}>
              <Text style={{..._theme.containerTitleText}}>
                My Pets: ({homeState.patientsData.length})
              </Text>
              <Button type="link" ficon="refresh-ccw" text={window.main.platform_os==="web" ? "Refresh" : ""} style={{marginTop:0,marginBottom:0,marginHorizontal:0,marginRight:0,paddingVertical:0,height:28,paddingLeft:20,paddingRight:0,}} onPress={fetchHomeData} />
            </View>

            <PatientList patients={homeState.patientsData} onCardPress={(pat)=>{homeSetState([{ key: "selectedPatientId", type: "number", selectedPatientId: Number(pat.patient_id)}])}} />

            {!homeState.appointmentsData.length>0 && (
              <View style={{flexDirection:"row",justifyContent:"center",marginBottom:24,width:"100%"}}>
                <Button text="Request Appointment" type="primary" size="large" style={{width:"100%",borderRadius:_theme.borderRadius}} onPress={onPressRequestAppt} />
              </View>
            )}
          </View>
        )}
      </View>
    </View>
  );
};
export default Home;